import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const formatCurrency = (amount) => {
  if (!amount) return '₹0';
  return `₹${Number(amount).toLocaleString('en-IN')}`;
};

const columns = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 160,
  },
  {
    field: 'totalFiles',
    headerName: 'Total Files',
    type: 'number',
    width: 110,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'approved',
    headerName: 'Approved',
    type: 'number',
    width: 100,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'disbursed',
    headerName: 'Disbursed',
    type: 'number',
    width: 100,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'rejected',
    headerName: 'Rejected',
    type: 'number',
    width: 100,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'approvalRate',
    headerName: 'Approval Rate (%)',
    type: 'number',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => {
      const rate = params.value || 0;
      const color = rate >= 70 ? '#1E8E3E' : rate >= 40 ? '#F9AB00' : '#D93025';
      return (
        <Box
          sx={{
            color: color,
            fontWeight: 600,
            backgroundColor: `${color}14`,
            px: 1.5,
            py: 0.25,
            borderRadius: 1.5,
            fontSize: '0.8rem',
          }}
        >
          {rate.toFixed(1)}%
        </Box>
      );
    },
  },
  {
    field: 'totalAmount',
    headerName: 'Total Amount',
    type: 'number',
    width: 150,
    align: 'right',
    headerAlign: 'right',
    valueFormatter: (value) => formatCurrency(value),
  },
];

const PerformanceTable = ({ data = [] }) => {
  const rows = data.map((item, index) => ({
    id: item.email || index,
    ...item,
  }));

  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: 2,
        border: '1px solid #DADCE0',
      }}
      elevation={0}
    >
      <Typography variant="h6" sx={{ fontWeight: 500, color: '#202124', fontSize: '1rem', mb: 2 }}>
        Team Performance
      </Typography>
      <Box sx={{ width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
            sorting: { sortModel: [{ field: 'totalFiles', sort: 'desc' }] },
          }}
          pageSizeOptions={[5, 10, 25]}
          disableRowSelectionOnClick
          autoHeight
          sx={{
            border: 'none',
            fontFamily: '"Google Sans", Roboto, sans-serif',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#F8F9FA',
              borderBottom: '1px solid #DADCE0',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 500,
              color: '#202124',
              fontSize: '0.8rem',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid #E8EAED',
              color: '#202124',
              fontSize: '0.85rem',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#F8F9FA',
            },
            '& .MuiDataGrid-footerContainer': {
              borderTop: '1px solid #DADCE0',
            },
          }}
        />
      </Box>
    </Paper>
  );
};

export default PerformanceTable;
